import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "border-b-2 border-gray-stroke pb-4" }
const _hoisted_2 = { class: "p-4 h-full" }
const _hoisted_3 = {
  key: 0,
  class: "pt-6"
}

import { UiTitle } from '@/components/common/ui'

type Props = {
    title?: string
    customClass?: string
}

export default /*#__PURE__*/_defineComponent({
  props: {
    title: { type: String, required: false },
    customClass: { type: String, required: false }
  },
  setup(__props: any) {

const props = __props as {
    title?: string
    customClass?: string
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mb-2 border border-gray rounded-lg p-4 lg:p-10 bg-white", __props.customClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.$slots.header)
        ? _renderSlot(_ctx.$slots, "header", { key: 0 })
        : (_openBlock(), _createBlock(_unref(UiTitle), { key: 1 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.title), 1)
            ]),
            _: 1
          }))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "content")
    ]),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})